@let _keys = keys();

@if (!_keys.messageDetails) {
	<div class="content">
		@if (_keys.title) {
			<span class="h1">{{ _keys.title }}</span>
		}
	</div>
	<ng-container *ngTemplateOutlet="footer" />
} @else {
	<header class="dialog-header">
		<div>
			<ng-content></ng-content>
		</div>
		<button [attr.title]="'close' | translate" [attr.aria-label]="'close' | translate" class="action" (click)="ok()">
			<i class="ico ico-close"></i>
		</button>
	</header>
	<article class="warning-container">
		@if (_keys.title) {
			<span class="h1">{{ _keys.title }}</span>
		}
		<p class="p1">{{ _keys.message }}</p>
		@if (_keys.messageDetails) {
			<div class="grouped-list">
				<div class="group">
					<header class="group-header">
						<div class="details-header" (click)="toggleList()">
							<span class="h3">
								<span>{{ _keys.messageDetails.header }}</span
								><span class="counter">{{ _keys.messageDetails.list.length }}</span>
							</span>
							<stages-button-expand-collapse
								[isCollapsed]="!messageDetailsExpanded"
								[classes]="'action'"
							></stages-button-expand-collapse>
						</div>
					</header>
					@if (messageDetailsExpanded) {
						<div class="details">
							<ul class="list">
								@for (entry of _keys.messageDetails.list; track entry) {
									<li class="list-item"><i class="ico ico-warning warning-color"></i> {{ entry }}</li>
								}
							</ul>
						</div>
					}
				</div>
			</div>
		}
	</article>
	<ng-content *ngTemplateOutlet="footer" />
}

<ng-template #footer>
	<footer>
		<stages-buttons-bottom [removeBoundaries]="true">
			@if (_keys.ok) {
				<button class="sm save" (click)="ok()" [translate]="_keys.ok"></button>
			}
		</stages-buttons-bottom>
	</footer>
</ng-template>
